import { FC, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import MileageCorrectionDisplay from "components/sections/objects/MileageCorrectionDisplay";
import OperationalHoursCorrectionDisplay from "components/sections/objects/OperationalHoursCorrectionDisplay";
import { MileageCorrectionCard } from "components/sections/objects/MileageCorrectionDisplay/MileageCorrectionDisplay.styled";

interface Props {
  specificObject: any;
  accountId: string;
}

const ObjectCorrectionsTabs: FC<Props> = ({ specificObject, accountId }) => {
  const { t } = useTranslation(["translation"]);
  const [tab, setTab] = useState(0);

  return (
    <MileageCorrectionCard sx={{ width: "100%", minWidth: 0 }}>
      <Tabs
        value={tab}
        onChange={(_, value: number) => setTab(value)}
        sx={{
          minHeight: 36,
          mb: 2,
          "& .MuiTab-root": {
            textTransform: "none",
            minHeight: 36,
            paddingY: 0.5
          },
          "& .MuiTab-root.Mui-selected": {
            color: "#845AFC"
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "#845AFC"
          }
        }}
      >
        <Tab label={t("typography.mileageCorrection")} />
        <Tab label={t("typography.operationalHoursCorrection")} />
      </Tabs>

      <Box>
        {tab === 0 ? (
          <MileageCorrectionDisplay
            embedded
            specificObject={specificObject}
            accountId={accountId}
          />
        ) : (
          <OperationalHoursCorrectionDisplay
            embedded
            specificObject={specificObject}
            accountId={accountId}
          />
        )}
      </Box>
    </MileageCorrectionCard>
  );
};

export default ObjectCorrectionsTabs;
